var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('div',{staticClass:"wrapper"},[_c('bing-map',{attrs:{"credentials":_vm.apiKey,"options":_vm.mapOptions}},[_c('bing-map-layer',[_c('bing-map-pushpin',{attrs:{"location":_vm.pin.location,"visible":true}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }